import React from 'react';
const { Component } = React;
import PropTypes from 'prop-types';

// services
import * as api from 'js/common/services/api';

// components
import Modal from 'js/common/components/Modal';

import PasswordAuth from './PasswordAuth';
import { MultiFactorAuth, MultiFactorAuthConnected } from './MultiFactorAuth';

// This component can now be used either as a controlled component that receives an errorCode
// or it can be used as a wrapper around a group of components and passing the onAuthExpired to all.
// Both implementations function equivalently.
// You must pass this component either a children function or an errorCode to work.

class AuthExpired extends Component {
  static isAuthExpired = (errorCode) => {
    return errorCode === 'MULTI_FACTOR_AUTH_EXPIRED' || errorCode === 'PASSWORD_AUTH_EXPIRED';
  };

  static propTypes = {
    promptWithinModal: PropTypes.bool,
    children: PropTypes.func,
    errorCode: PropTypes.string,
    onSuccess: PropTypes.func,
    username: PropTypes.string,
  };

  static defaultProps = {
    promptWithinModal: false,
    errorCode: '',
    children: () => {},
    onSuccess: () => {},
    username: '',
  };

  state = {
    type: null,
  };

  onAuthExpired = api.utils.isAuthExpired({
    password: () => this.setState({ type: 'password' }),
    multifactor: () => this.setState({ type: 'multifactor' }),
  });

  onSuccess = () => {
    const { onSuccess } = this.props;
    this.setState({ type: null });
    onSuccess();
  };

  closeModal = () => this.setState({ type: false });

  render() {
    const { children, promptWithinModal, errorCode, username } = this.props;
    const { type } = this.state;

    let verifyElement;
    if (type === 'multifactor' || errorCode === 'MULTI_FACTOR_AUTH_EXPIRED') {
      if (username) {
        verifyElement = <MultiFactorAuth onSuccess={this.onSuccess} username={username} />;
      } else {
        verifyElement = <MultiFactorAuthConnected onSuccess={this.onSuccess} />;
      }
    } else if (type === 'password' || errorCode === 'PASSWORD_AUTH_EXPIRED') {
      verifyElement = <PasswordAuth onSuccess={this.onSuccess} />;
    }

    if (promptWithinModal && verifyElement) {
      verifyElement = <Modal onClose={this.closeModal}>{verifyElement}</Modal>;
    }

    const showChildren = (promptWithinModal || !verifyElement) && !errorCode;

    return (
      <div>
        {verifyElement}
        {showChildren && children({ onAuthExpired: this.onAuthExpired })}
      </div>
    );
  }
}

export default AuthExpired;
